<template>
  <div class="promocode-page shop-offers-base">
    <div class="title header-title-wrap-bc">
      <div class="l-container">
        <h2 class="text-h2-bold-up">Промокоды</h2>
      </div>
    </div>

    <div class="l-container promocodes-content">
      <div class="shop-promocodes">
        <div class="promocode-cards">
          <template v-if="pageData.promocodes?.length">
            <PromocodeCard
              v-for="(item, index) in pageData.promocodes"
              :key="index"
              class="promocode-card"
              :data="item"
            />
          </template>
          <EmptyState v-else image="/static/images/sad-smiley.svg">
            <template #title>
              К сожалению, сейчас в данном магазине нет активных промокодов
            </template>
            Попробуйте зайти позже или обратите внимание на акции других
            <br class="br-desktop" />
            магазинов в разделе
            <nuxt-link to="/promokody/">все промокоды</nuxt-link>
          </EmptyState>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { DynamicPageContext } from '~/interfaces/api';
import PromocodeCard from '~/components/promocodes/promocode-card/promocode-card.vue';
import EmptyState from '@/components/ui/empty-state/empty-state.vue';

defineProps({
  data: {
    type: Object as () => DynamicPageContext,
    required: true,
  },
  pageData: {
    type: Object as any,
    required: true,
  },
});
</script>
<style scoped lang="scss" src="./PromocodesScss.scss"></style>
